export const YEAR_MONTH_DAY_DATE_FORMAT = 'yyyy-MM-dd';
export const MONTH_DAY_YEAR_DATE_FORMAT = 'MMM / dd / yyyy';
export const MONTH_YEAR_DATE_FORMAT = 'MMM / yyyy';
export const MONTH_DAY_DATE_FORMAT = 'MMM dd';
export const HOUR_MINUTE_DATE_FORMAT = 'h:mm a';
